import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { BaseRecentSubNav } from "../services/base-recent-sub-nav";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";

@Component({
  selector: "gh-tasks-sub-navigation",
  templateUrl: "./tasks-sub-navigation.component.html",
})
export class TasksSubNavigationComponent extends BaseRecentSubNav implements OnInit {
  @Output() titleChange = new EventEmitter<string>();
  public options: SubNavOption[] = [{ label: "My Tasks", state: "gtmhub.tasks" }];

  private sectionTitle = "Tasks";

  constructor(protected navigationItemsFacade: NavigationItemsFacade) {
    super();
    this.setupEntityTypes(["task"], "tasks");
  }

  ngOnInit() {
    super.ngOnInit();
    this.titleChange.emit(this.sectionTitle);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
